import { render, staticRenderFns } from "./WorkHeaderPicker.vue?vue&type=template&id=5a504219&scoped=true"
import script from "./WorkHeaderPicker.vue?vue&type=script&lang=js"
export * from "./WorkHeaderPicker.vue?vue&type=script&lang=js"
import style0 from "./WorkHeaderPicker.vue?vue&type=style&index=0&id=5a504219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a504219",
  null
  
)

export default component.exports